module.exports = __webpack_public_path__ + "img/jo.c8c106d0.jpg";